import { TypedEmitter } from 'tiny-typed-emitter'

interface Events<T> {
    trigger: (v: T) => void
}

export class Trigger<T> extends TypedEmitter<Events<T>> {
    trigger(v: T) {
        this.emit('trigger', v)
    }
}
